export interface IColumn {
    title: string
    dataIndex: string
    key: string
}

export enum statusType {
    a = 0,
    b = 25,
    c = 50,
    d = 75,
    e = 100,
}

export interface IRow {
    id: number
    patent_name: string
    description: string
    service_calls: string
    progress: statusType
    last_update: string
}
